// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { InvoiceRmaLine } from "@store/Framework/Types/ApiModels";

type HandlerType = Handler<{ invoiceNumber: string; invoiceRmaLine: InvoiceRmaLine }>;

export const DispatchUpdateInvoiceRmaLine: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ReturnRequest/UpdateInvoiceRmaLine",
        invoiceNumber: props.parameter.invoiceNumber,
        invoiceRmaLine: props.parameter.invoiceRmaLine,
    });
};

export const chain = [DispatchUpdateInvoiceRmaLine];

const updateInvoiceRmaLine = createHandlerChainRunner(chain, "UpdateInvoiceRmaLine");
export default updateInvoiceRmaLine;
